import type { PropertiesNullable } from '@@types/helpers'
import type {
  Maybe,
  Plugin,
  PluginParameter
} from '@server/graphql/typeDefs/types'
import EntityBase from './EntityBase'

export default class EntityPlugin
  extends EntityBase
  implements PropertiesNullable<Plugin>
{
  id: Maybe<number> = null
  name: Maybe<string> = null
  parameters: Maybe<PluginParameter[]> = null

  constructor(data: Partial<Plugin>) {
    super()
    Object.assign(this, data)
  }
}
